import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { AlertTitle } from './AlertTitle';
import { AlertDescription } from './AlertDescription';
import { AlertProps } from './types';
import { containerStyles } from './alert.styles';
import { iconMap } from './constants';
import { AlertActionButton } from './AlerActionButton';

export const Alert: FC<AlertProps> = ({ type, title, description, actionButtonText, onAction }) => {
  return (
    <div className={twMerge('flex', containerStyles({ type }))}>
      <div className='shrink-0'>{iconMap[type]}</div>
      <div className='flex flex-col gap-2 p-2'>
        <AlertTitle text={title} type={type} />
        {description && <AlertDescription text={description} type={type} />}
        {actionButtonText && <AlertActionButton type={type} actionButtonText={actionButtonText} onAction={onAction} />}
      </div>
    </div>
  );
};
